import type { Dict } from './en.ts';

export const fa: Dict = {
  ui: {
    'doc.title': 'طوفان مانا',
    'title.tagline': 'از دل هجوم زنده بمان. طوفان شو.',
    'title.gold': '{n} طلا',
    'title.level': 'سطح {n}',
    'title.levelXp': '{into} از {need} تجربه تا سطح بعد',
    'title.hintKeys': 'حرکت با نشانگر ماوس، WASD یا جهت‌نماها · جهش با Space یا کلیک راست · مکث با Esc',
    'title.hintTouch': 'برای حرکت بکشید · دکمه‌ی جهش را لمس کنید · ❚❚ برای مکث',
    'menu.play': 'شروع',
    'menu.shop': 'کتاب طلسم',
    'menu.shopReady': 'طلای یک ارتقا را داری',
    'menu.settings': 'تنظیمات',
    'menu.howto': 'راهنمای بازی',
    'menu.install': 'نصب بازی',
    'install.title': 'نصب طوفان مانا',
    'install.ios1': 'در نوار پایین Safari روی <b>اشتراک‌گذاری</b> <bdi dir="ltr">(Share)</bdi> بزنید.',
    'install.ios2': '<b>افزودن به صفحه اصلی</b> <bdi dir="ltr">(Add to Home Screen)</bdi> را انتخاب کنید و بعد <b>افزودن</b> <bdi dir="ltr">(Add)</bdi> را بزنید.',
    'install.ok': 'متوجه شدم',
    'menu.language': 'English',
    'common.back': 'بازگشت',
    'common.continue': 'ادامه',
    'common.fullscreen': 'تمام‌صفحه',
    'common.exitFullscreen': 'خروج از تمام‌صفحه',
    'howto.title': 'راهنمای بازی',
    'howto.1': '<b>حرکت</b> با نشانگر ماوس (جادوگر دنبالش می‌رود)، یا با WASD و جهت‌نماها: طلسم‌ها خودکار اجرا می‌شوند؛ جای ایستادن شما همه‌چیز را تعیین می‌کند.',
    'howto.2': '<b>جواهرهای مانا</b> را جمع کنید تا سطح بالا بروید و یکی از ۳ ارتقا را انتخاب کنید.',
    'howto.3': '<b>جهش</b> (با Space، کلیک راست یا دکمه‌ی جهش) شما را از میان دشمنان رد می‌کند و برای چند لحظه آسیب نمی‌بینید.',
    'howto.4': '<b>زمین قرمز</b> یعنی خطر؛ وقتی رنگ داخلش پر شود، ضربه می‌زند.',
    'howto.5': '<b>دشمنان نخبه</b> صندوق رها می‌کنند. طلسمی که به بالاترین سطح برسد و توانایی ثابت مربوطش را هم داشته باشد، از داخل صندوق <b>تکامل</b> می‌یابد.',
    'howto.6': '<b>آتشدان‌ها</b> را بشکنید؛ در آن‌ها غذا، آهن‌ربا، بمب و طلسم توقف زمان پیدا می‌شود.',
    'howto.7': '<b>تا ۸:۰۰ زنده بمانید</b>، سپس غول آخر را شکست دهید تا قلمرو را تمام کنید و قلمرو بعدی باز شود.',
    'howto.8': 'با طلا در <b>کتاب طلسم</b> ارتقاهای دائمی بخرید.',
    'select.chooseMage': 'جادوگر خود را انتخاب کنید',
    'select.chooseRealm': 'قلمرو را انتخاب کنید',
    'select.begin': 'شروع',
    'select.lockedChar': '{stage} را تکمیل کنید',
    'select.lockedStage': 'قفل است: قلمرو قبلی را تکمیل کنید',
    'select.best': 'بهترین: {time}',
    'select.cleared': 'تکمیل شد',
    'shop.title': 'کتاب طلسم',
    'shop.perRank': '{desc} در هر رتبه',
    'shop.maxed': 'حداکثر',
    'shop.offline': 'برای خرید به اینترنت وصل شوید',
    'menu.armory': 'زرادخانه',
    'armory.title': 'زرادخانه',
    'armory.equipped': 'تجهیزات',
    'armory.chests': 'صندوقچه‌ها',
    'armory.inventory': 'انبار {n} / {max}',
    'armory.empty': 'برای یافتن تجهیزات یک صندوقچه بخرید.',
    'armory.full': 'انبار پر است: اول چیزی را بازیافت کنید',
    'armory.emptySlot': 'خالی',
    'armory.found': 'غنیمت تازه',
    'armory.equip': 'تجهیز',
    'armory.keep': 'نگه‌داشتن',
    'armory.salvage': 'بازیافت ◉ {n}',
    'armory.worn': 'در حال استفاده',
    'armory.tabEquipment': 'تجهیزات',
    'armory.tabChests': 'صندوقچه‌ها',
    'armory.tabMarket': 'فروشگاه',
    'armory.marketHint': 'همان تجهیزی را بخرید که می‌خواهید. میزان ویژگی‌ها هنگام خرید تعیین می‌شود.',
    'armory.upTo': 'تا {stat}',
    'armory.buy': 'خرید',
    'armory.damage': 'آسیب +{v}٪',
    'armory.maxHp': 'حداکثر جان {v}',
    'armory.level': 'سطح {n}',
    'armory.enhance': 'ارتقا ◉ {n}',
    'armory.reforge': 'بازآفرینی ◉ {n}',
    'armory.fuse': 'ترکیب ۳←۱ ({rarity})',
    'armory.fuseNeed': 'ترکیب ۳←۱ (نیاز به ۳)',
    'armory.maxLevel': 'حداکثر سطح',
    'armory.salvageCommons': 'بازیافت همه‌ی معمولی‌ها',
    'armory.keepAll': 'نگه‌داشتن همه',
    'armory.x1': '۱ بار',
    'armory.x10': '۱۰ بار',
    'armory.guarantee': '{rarity} یا بهتر تا {within} گشایش · {left} مانده',
    'armory.guaranteeTop': '{rarity} تا {within} گشایش · {left} مانده',
    'armory.needSpace': 'به {n} جای خالی نیاز دارد',
    'armory.next': 'سطح بعد',
    'armory.setProgress': '{name} ({n}/۴)',
    'armory.setBonus': '({n}) {stats}',
    'armory.setChip': '{name} ({n})',
    'armory.legendaryPerk': '★ {name}: {desc}',
    'set.ember': 'مجموعه‌ی اخگر',
    'set.storm': 'مجموعه‌ی طوفان',
    'set.verdant': 'مجموعه‌ی سرسبز',
    'set.void': 'مجموعه‌ی خلأ',
    'perk.arc_pulse.name': 'تپش آرکین',
    'perk.arc_pulse.desc': 'هر ۶ ثانیه موجی جادویی آزاد می‌کند که دشمنان نزدیک را عقب می‌راند و آسیب می‌زند',
    'perk.scholar_crown.name': 'تاج دانش‌پژوه',
    'perk.scholar_crown.desc': 'در هر ارتقای سطح ۴ گزینه نشان داده می‌شود و با ۱ تعویض بیشتر شروع می‌کنید',
    'perk.sanctified_hearth.name': 'آتشدان مقدس',
    'perk.sanctified_hearth.desc': 'شکستن هر آتشدان ۱۵ جان بازمی‌گرداند و ۱۵ طلای اضافه می‌دهد',
    'perk.aegis_pulse.name': 'حفاظ ایجیس',
    'perk.aegis_pulse.desc': 'هنگام دریافت ضربه موج ضربه‌ای آزاد می‌کند و ۱٫۵ ثانیه مصونیت می‌دهد (۸ ثانیه بازیابی)',
    'perk.alchemist_loop.name': 'حلقه‌ی کیمیاگر',
    'perk.alchemist_loop.desc': 'سکه‌های طلا ۴ جان بازمی‌گرداند و ۵ تجربه می‌دهد',
    'perk.stormstep.name': 'گام طوفان',
    'perk.stormstep.desc': 'جهش موجی آزاد می‌کند که دشمنان را کند می‌سازد و ۲۰٪ سریع‌تر آماده می‌شود',
    'slot.staff': 'عصا',
    'slot.hat': 'کلاه',
    'slot.robe': 'ردا',
    'slot.amulet': 'گردنبند',
    'slot.ring': 'انگشتر',
    'slot.boots': 'چکمه',
    'rarity.common': 'معمولی',
    'rarity.rare': 'کمیاب',
    'rarity.epic': 'حماسی',
    'rarity.legendary': 'افسانه‌ای',
    'chest.bronze': 'صندوقچه‌ی برنزی',
    'chest.silver': 'صندوقچه‌ی نقره‌ای',
    'chest.gold': 'صندوقچه‌ی طلایی',
    'gear.might': '+{v}٪ آسیب',
    'gear.crit': '+{v}٪ ضربه‌ی کاری',
    'gear.haste': '-{v}٪ زمان بازیابی',
    'gear.area': '+{v}٪ گستره',
    'gear.duration': '+{v}٪ مدت‌زمان',
    'gear.maxHp': '+{v} حداکثر جان',
    'gear.armor': '+{v} زره',
    'gear.regen': '+{v} جان در ثانیه',
    'gear.moveSpeed': '+{v}٪ سرعت حرکت',
    'gear.magnet': '+{v}٪ شعاع جمع‌آوری',
    'gear.growth': '+{v}٪ تجربه',
    'gear.greed': '+{v}٪ طلا',
    'gear.luck': '+{v}٪ شانس گزینه‌ی چهارم',
    'settings.title': 'تنظیمات',
    'settings.graphics': 'گرافیک',
    'settings.quality.auto': 'خودکار',
    'settings.quality.low': 'پایین',
    'settings.quality.medium': 'متوسط',
    'settings.quality.high': 'بالا',
    'settings.sfx': 'جلوه‌های صوتی',
    'settings.music': 'موسیقی',
    'settings.shake': 'لرزش صفحه',
    'settings.numbers': 'اعداد آسیب',
    'settings.language': 'زبان',
    'settings.controls': 'کنترل لمسی',
    'settings.joystick': 'اهرم حرکت',
    'settings.joystick.floating': 'شناور (در محل لمس ظاهر می‌شود)',
    'settings.joystick.fixed': 'ثابت (گوشه‌ی پایین)',
    'settings.leftHanded': 'چیدمان چپ‌دست',
    'settings.haptics': 'ارتعاش',
    'lang.en': 'English',
    'lang.fa': 'فارسی',
    'hud.level': 'سطح {n}',
    'hud.blink': 'جهش',
    'hud.pause': 'مکث',
    'hud.hp': '{hp} / {max}',
    'hud.pace': '{n} کشته نسبت به بهترین دور شما در همین زمان',
    'hud.max': 'کامل',
    'marker.boss': 'غول آخر',
    'marker.elite': 'نخبه',
    'marker.chest': 'صندوق',
    'marker.shrine': 'نیایشگاه',
    'shrine.arcane.title': 'نیایشگاه آرکین',
    'shrine.arcane.sub': '+۳۵ جان · +۳۵٪ آسیب و +۲۵٪ سرعت بازیابی برای ۲۰ ثانیه',
    'shrine.cursed.title': 'قربانگاه نفرین‌شده',
    'shrine.cursed.sub': 'قربانی خون! نخبگان در کنار صندوق گنج بیدار شدند',
    'shrine.obelisk.title': 'ستون طلایی',
    'shrine.obelisk.sub': '+۷۵ طلا · جذب همه‌ی گوهرهای تجربه',
    'levelup.title': 'سطح {n}',
    'levelup.choose': 'یک ارتقا انتخاب کنید',
    'levelup.waiting': 'هنوز {n} ارتقا مانده است',
    'levelup.rerolled': 'گزینه‌ها عوض شدند',
    'levelup.reroll': 'تعویض گزینه‌ها ({n})',
    'card.newSpell': 'طلسم جدید',
    'card.new': 'جدید',
    'card.level': 'سطح {a} ← {b}',
    'card.levelMax': 'سطح {a} ← حداکثر',
    'card.evolvesWith': 'با {name} تکامل می‌یابد',
    'card.evolves': '{name} را تکامل می‌دهد',
    'card.evolved': 'تکامل‌یافته',
    'card.bonus': 'پاداش',
    'card.treasure': 'گنج',
    'card.goldCache': 'انبار طلا',
    'card.goldCacheDesc': '+۲۵ طلا',
    'card.draught': 'معجون درمان',
    'card.draughtDesc': 'بازگرداندن ۴۰ جان',
    'card.gold': '{n} طلا',
    'card.goldDesc': 'به کیسه‌ی شما اضافه می‌شود',
    'chest.evolution': 'تکامل!',
    'chest.evolvedSub': '{name} تکامل یافت',
    'chest.treasure': 'گنج!',
    'chest.bountiful': 'یک صندوق پرگنج',
    'chest.holds': 'صندوق در خود دارد…',
    'pause.title': 'بازی متوقف شد',
    'pause.sub': '{stage} · {time} · سطح {n}',
    'pause.none': 'هنوز توانایی ثابتی نیست',
    'pause.abandon': 'ترک نبرد',
    'pause.resume': 'ادامه',
    'stat.damage': 'آسیب',
    'stat.cooldown': 'زمان بازیابی',
    'stat.area': 'گستره',
    'stat.projectiles': 'پرتابه‌ها',
    'stat.speed': 'سرعت',
    'stat.armor': 'زره',
    'stat.regen': 'بازسازی',
    'stat.regenValue': '{v} در ثانیه',
    'stat.crit': 'ضربه‌ی کاری',
    'table.spell': 'طلسم',
    'table.level': 'سطح',
    'table.damage': 'آسیب',
    'table.dps': 'آسیب/ثانیه',
    'table.evo': 'تکامل',
    'results.victory': 'پیروزی',
    'results.defeated': 'شکست',
    'results.cleared': '{stage} تکمیل شد',
    'results.joins': '{name}، {title}، به شما می‌پیوندد',
    'results.slain': '{killer} شما را در {time} از پا درآورد',
    'results.survived': 'زمان بقا',
    'results.level': 'سطح',
    'results.kills': 'کشته‌ها',
    'results.gold': 'طلا',
    'results.xp': 'تجربه',
    'results.mainLevelUp': 'سطح اصلی {n}! +{gold} طلا · اکنون +{dmg}٪ آسیب و +{hp} جان بیشتر',
    'results.bossLoot': 'غنیمت غول آخر: {name} ({rarity})',
    'results.canBuy': 'حالا می‌توانی {name} ({desc}) را از کتاب طلسم بخری',
    'results.endless': 'ورود به شکاف بی‌پایان',
    'select.stormTier': 'رتبه‌ی طوفان',
    'select.stormNormal': 'شدت عادی قلمرو',
    'select.stormDesc': 'جان دشمن +{hp}٪ · آسیب +{dmg}٪ · طلا +{gold}٪',
    'banner.endless': 'شکاف بی‌پایان',
    'banner.endlessSub': 'در برابر طوفان فزاینده تا می‌توانید دوام بیاورید!',
    'shop.tabUpgrades': 'ارتقاها',
    'shop.tabEvolutions': 'تکامل‌ها',
    'shop.tabBestiary': 'هیولانامه',
    'codex.discovered': 'کشف‌شده',
    'codex.undiscovered': 'برای نمایش، در نبرد تکامل دهید',
    'codex.slain': 'کشته‌شده: {n} از {max}',
    'codex.claim': 'دریافت ◉ {n}',
    'codex.claimed': 'تکمیل‌شده',
    'results.next': 'قلمرو بعدی',
    'results.again': 'بازی دوباره',
    'results.retry': 'تلاش دوباره',
    'results.menu': 'منوی اصلی',
    'killer.projectile': 'یک پرتابه',
    'killer.ground': 'زمین',
    'killer.curse': 'یک نفرین',
    'killer.rift': 'شکاف',
    'killer.sandstorm': 'طوفان شن',
    'killer.rockfall': 'تخته‌سنگ',
    'killer.horde': 'هجوم دشمنان',
    'hud.wave': 'موج {n}',
    'banner.surrounded': 'محاصره شدید!',
    'banner.surroundedSub': 'حلقه را بشکنید',
    'banner.swarm': 'انبوهی از دشمنان نزدیک می‌شوند',
    'banner.swarmSub': 'از مسیرش کنار بروید',
    'banner.elite': 'یک دشمن نخبه نزدیک می‌شود',
    'banner.eliteSub': 'یک صندوق گنج با خود دارد',
    'banner.enraged': 'خشمگین شد!',
    'banner.blizzard': 'کولاک!',
    'banner.blizzardSub': 'باد شما را هل می‌دهد',
    'banner.sandstorm': 'طوفان شن!',
    'banner.sandstormSub': 'شن شما را هل می‌دهد و می‌سوزاند',
    'banner.rockfall': 'ریزش سنگ!',
    'banner.rockfallSub': 'دیوها تخته‌سنگ پرتاب می‌کنند',
    'banner.rift': 'شکافی باز می‌شود',
    'banner.riftSub': 'همه‌چیز را به درون می‌کشد',
    'banner.phoenix': 'ققنوس برمی‌خیزد',
    'banner.phoenixSub': 'یک فرصت دیگر',
    'banner.timeStop': 'توقف زمان',
    'banner.evolution': 'تکامل',
    'banner.victory': 'پیروزی',
    'banner.fallen': '{name} از پا درآمد',
    'float.gold': '+طلا',
    'upg.damage': 'آسیب',
    'upg.count': 'تعداد',
    'upg.area': 'گستره',
    'upg.speed': 'سرعت',
    'upg.pierce': 'نفوذ',
    'upg.chains': 'زنجیره',
    'upg.knockback': 'نیرو',
    'upg.range': 'برد',
    'upg.add': '{v} {label}',
    'upg.cooldown': '{v} ثانیه زمان بازیابی',
    'upg.duration': '{v} ثانیه مدت',
    'upg.slow': '{v}٪ کندی',
    'upg.tick': 'ضربه‌های سریع‌تر',
    'upg.join': '، ',
    'menu.account': 'ورود',
    'menu.leaderboard': 'جدول امتیازها',
    'account.title': 'حساب کاربری',
    'account.signIn': 'ورود',
    'account.register': 'ثبت‌نام',
    'account.email': 'ایمیل',
    'account.password': 'رمز عبور',
    'account.name': 'نام بازیکن',
    'account.nameHint': 'در جدول امتیازها نمایش داده می‌شود',
    'account.submitSignIn': 'ورود',
    'account.submitRegister': 'ساخت حساب',
    'account.signedInAs': 'با نام {name} وارد شده‌اید',
    'account.synced': 'پیشرفت شما در حسابتان ذخیره می‌شود و روی همه‌ی دستگاه‌ها یکسان است.',
    'account.guestNote': 'برای بازی وارد شوید یا یک حساب رایگان بسازید. پیشرفتتان آنلاین ذخیره می‌شود و در جدول امتیازها حضور خواهید داشت.',
    'account.signOut': 'خروج از حساب',
    'account.close': 'بستن',
    'account.err.email': 'یک ایمیل معتبر وارد کنید',
    'account.err.password': 'رمز عبور باید بین ۸ تا ۱۲۸ نویسه باشد',
    'account.err.name': 'نام باید ۳ تا ۲۰ نویسه از حرف، عدد یا فاصله باشد',
    'account.err.emailTaken': 'این ایمیل قبلاً ثبت شده است',
    'account.err.nameTaken': 'این نام قبلاً انتخاب شده است',
    'account.err.credentials': 'ایمیل یا رمز عبور اشتباه است',
    'account.err.rate': 'تلاش‌ها زیاد بود. چند دقیقه‌ی دیگر دوباره امتحان کنید.',
    'account.err.network': 'اتصال به سرور برقرار نشد',
    'account.err.generic': 'مشکلی پیش آمد',
    'account.err.expired': 'مهلت ورود با تلگرام تمام شد. دوباره امتحان کنید.',
    'account.err.telegram': 'ورود با تلگرام فعلاً در دسترس نیست',
    'account.or': 'یا',
    'account.telegram': 'ورود با تلگرام',
    'account.tgWaiting': 'ربات ما را در تلگرام باز کنید، «شروع» را بزنید و بعد همین عدد را آنجا بزنید. این صفحه خودش ادامه می‌دهد.',
    'account.tgMatch': 'عدد شما',
    'account.tgOpen': 'باز کردن تلگرام',
    'account.tgPending': 'در انتظار تأیید…',
    'account.tgBack': 'بازگشت',
    'account.tgConnect': 'اتصال تلگرام',
    'account.tgConnectNote': 'بعد از آن می‌توانید با تلگرام هم وارد همین حساب شوید.',
    'account.err.telegramTaken': 'این حساب تلگرام به بازیکن دیگری وصل است',
    'account.err.alreadyLinked': 'یک حساب تلگرام قبلاً به این بازیکن وصل شده است',
    'leaderboard.title': 'جدول امتیازها',
    'leaderboard.rank': 'رتبه',
    'leaderboard.player': 'بازیکن',
    'leaderboard.all': 'همه',
    'leaderboard.cleared': 'قلمروها',
    'leaderboard.kills': 'کشته‌ها',
    'leaderboard.time': 'زمان',
    'leaderboard.level': 'سطح',
    'leaderboard.you': 'شما',
    'leaderboard.empty': 'هنوز نبردی ثبت نشده است. اولین نفر باشید!',
    'leaderboard.signInHint': 'برای ثبت نبردهایتان در جدول وارد شوید.',
    'leaderboard.loading': 'در حال بارگذاری…',
    'leaderboard.offline': 'جدول امتیازها فعلاً در دسترس نیست.',
    'leaderboard.yourBest': 'بهترین نتیجه‌ی شما: رتبه‌ی {n}',
    'results.submitted': 'رتبه در جدول امتیازها: {n}',
    'results.newBest': 'رکورد تازه‌ی شما! رتبه در جدول امتیازها: {n}',
    'results.signInToSubmit': 'برای ثبت نبردها در جدول امتیازها وارد شوید',
    'results.notSaved': 'این نبرد ثبت نشد',
    'results.syncing': 'در حال ثبت جایزه‌ها…',
    'results.tainted': 'نبرد تمرینی یا تغییریافته: در جدول امتیازها ثبت نشد',
    'reaction.shatter': 'فروپاشی یخ!',
    'reaction.superconduct': 'ابررسانا!',
    'reaction.toxic_ignition': 'اشتعال سمی!',
    'reaction.singularity_shock': 'شوک خلأ!',
    'daily.title': 'آزمون روزانه‌ی طوفان',
    'daily.play': 'شروع آزمون روزانه',
    'daily.bounty': 'پاداش اولین نبرد: ◉ {n}',
    'daily.claimed': 'پاداش امروز دریافت شد ✓',
    'daily.bannerSub': 'آزمون روزانه · {m1} و {m2}',
    'daily.short': 'آزمون روزانه',
    'daily.streak': '{n} روز پیاپی',
    'daily.endsIn': '{time} تا پایان',
    'daily.nextIn': 'انجام شد ✓ · آزمون بعدی تا {time}',
    'leaderboard.daily': 'روزانه',
    'results.dailyRank': 'رتبه در جدول روزانه: {n}',
    'results.dailyBest': 'بهترین نتیجه‌ی امروز! رتبه در جدول روزانه: {n}',
    'mutator.glass_cannon.name': 'توپ شیشه‌ای',
    'mutator.glass_cannon.desc': '+۶۰٪ آسیب، -۳۵ حداکثر جان',
    'mutator.hypercharge.name': 'فراشتاب',
    'mutator.hypercharge.desc': '-۳۰٪ زمان بازیابی، +۲۰٪ سرعت دشمن',
    'mutator.volatile_horde.name': 'لشکر انفجاری',
    'mutator.volatile_horde.desc': 'انفجار دشمنان هنگام مرگ، +۲۰٪ گستره',
    'mutator.blood_bounty.name': 'غنیمت خونین',
    'mutator.blood_bounty.desc': '+۷۵٪ طلا، +۱۰٪ ضربه‌ی کاری، -۵۰٪ درمان',
    'mutator.swarm_surge.name': 'خیزش لشکر',
    'mutator.swarm_surge.desc': '+۳۵٪ نرخ ظهور، +۳۵٪ تجربه و جذب',
    'levelup.banish': 'حذف ({n})',
    'levelup.banished': '{name} حذف شد',
    'levelup.lock': 'قفل',
    'levelup.locked': 'قفل شد ✓',
    'shrine.anvil.title': 'سندان اختری',
    'shrine.anvil.sub': 'آهنگری شد! +۱ سطح طلسم و +۲۵ جان',
    'select.mastery': '★ رتبه‌ی {n}',
    'results.masteryUp': 'رتبه‌ی استادی جادوگر {n}! +{dmg}٪ آسیب و +{hp} جان',
    'affix.warlord': 'جنگ‌سالار',
    'affix.bulwark': 'سنگرپوش',
    'affix.splitter': 'دوپاره',
    'affix.hoarder': 'گنج‌اندوز',
  },
  spells: {
    arcane_bolt: { name: 'تیر جادو', desc: 'تیرهای ردیاب به سراغ نزدیک‌ترین دشمنان می‌روند.', evoName: 'رگبار ستاره‌ای', evoDesc: 'جریانی بی‌امان از ستاره‌تیرهای نافذ.' },
    fireball: { name: 'آتش‌گوی', desc: 'گوی‌های آتشین پرتاب می‌کند که با برخورد منفجر می‌شوند.', evoName: 'دنباله‌دار دوزخی', evoDesc: 'دنباله‌دارهایی که زمین محل برخوردشان را می‌سوزانند.' },
    frost_nova: { name: 'انفجار یخی', desc: 'موجی یخ‌زننده که دشمنان را کند و عقب می‌راند.', evoName: 'صفر مطلق', evoDesc: 'هر چیزی را در شعاعی وسیع کاملاً منجمد می‌کند.' },
    chain_lightning: { name: 'صاعقه‌ی زنجیره‌ای', desc: 'صاعقه‌ای که میان دشمنان می‌جهد.', evoName: 'ارباب طوفان', evoDesc: 'طوفان‌هایی از صاعقه‌های شاخه‌شاخه با بردی بی‌پایان.' },
    spirit_orbs: { name: 'گوی‌های روح', desc: 'گوی‌هایی که دورتان می‌چرخند و به هر دشمنی که برسند ضربه می‌زنند.', evoName: 'هاله‌ی آسمانی', evoDesc: 'حلقه‌ای دائمی از ارواح تابناک.' },
    venom_pool: { name: 'شیشه‌ی زهر', desc: 'شیشه‌هایی را می‌شکند که برکه‌های سمی به جا می‌گذارند.', evoName: 'باغ زهرآلود', evoDesc: 'باتلاق‌های وسیع و خفه‌کننده که هجوم را فلج می‌کنند.' },
    radiant_lance: { name: 'نیزه‌ی تابان', desc: 'پرتوی نافذ که در جهت حرکت شما شلیک می‌شود.', evoName: 'داوری خورشیدی', evoDesc: 'چهار ستون خیره‌کننده از نور خورشید.' },
    wind_scythe: { name: 'داس بادی', desc: 'تیغه‌ای چرخان که به سوی شما برمی‌گردد.', evoName: 'هلال طوفانی', evoDesc: 'تیغه‌های گردبادی عظیمی که همه‌چیز را تکه‌تکه می‌کنند.' },
    earth_spike: { name: 'خار زمینی', desc: 'خارهای سنگی زیر پای دشمنان فوران می‌کنند.', evoName: 'خشم تیتان', evoDesc: 'کوه‌ها از دل زمین بیرون می‌آیند.' },
    shadow_dagger: { name: 'خنجر سایه', desc: 'خنجرهای سریعی که به سوی روبه‌رو پرتاب می‌شوند.', evoName: 'هزار سایه', evoDesc: 'تیغه‌هایی که از جلو و پشت سر شما پخش می‌شوند.' },
    gravity_well: { name: 'چاه گرانش', desc: 'گردابی که دشمنان را به درون می‌کشد و له می‌کند.', evoName: 'افق رویداد', evoDesc: 'تکینگی‌های فروریزنده‌ی هجوم دشمنان را می‌بلعند.' },
    sunfire_aura: { name: 'هاله‌ی خورشیدی', desc: 'هاله‌ای سوزان که دشمنان نزدیک را می‌سوزاند و عقب می‌راند.', evoName: 'تاج خورشیدی', evoDesc: 'خورشیدی کوچک دور شما می‌سوزد.' },
    crystal_shards: { name: 'تراشه‌های بلور', desc: 'تراشه‌های بلوری به هر سو پرتاب می‌شوند.', evoName: 'طوفان منشور', evoDesc: 'حلقه‌هایی بی‌پایان از تراشه‌های منشوری نافذ.' },
    blood_siphon: { name: 'مکش خون', desc: 'جان نزدیک‌ترین دشمنان را می‌مکد و شما را درمان می‌کند.', evoName: 'ضیافت سرخ', evoDesc: 'رشته‌های خونین جان کل لشکر دشمن را سر می‌کشند.' },
    rune_trap: { name: 'تله‌ی رون', desc: 'رون‌هایی می‌گذارد که با قدم دشمن منفجر می‌شوند.', evoName: 'میدان طلسم', evoDesc: 'زمینی پر از رون که هجوم را درهم می‌شکند.' },
    tidal_wave: { name: 'موج خروشان', desc: 'موجی پرشتاب که دشمنان را با خود می‌برد.', evoName: 'خیزاب لویاتان', evoDesc: 'امواجی که به هر سو می‌کوبند.' },
  },
  passives: {
    might: { name: 'قدرت جادویی', desc: '+۱۰٪ آسیب' },
    quickening: { name: 'تسریع', desc: '-۷٪ زمان بازیابی' },
    expansion: { name: 'گسترش', desc: '+۱۰٪ گستره' },
    echo: { name: 'مهر پژواک', desc: '+۱ پرتابه' },
    boots: { name: 'چکمه‌های چابک', desc: '+۸٪ سرعت حرکت' },
    heart: { name: 'قلب حیاتی', desc: '+۲۰ حداکثر جان' },
    lode: { name: 'سنگ آهن‌ربا', desc: '+۲۵٪ شعاع جمع‌آوری' },
    tome: { name: 'دفتر دانش', desc: '+۸٪ تجربه' },
    iron: { name: 'پوست آهنین', desc: '+۱ زره' },
    bloom: { name: 'شکوفه‌ی حیات', desc: '+۰٫۳ بازسازی جان در ثانیه' },
    chrono: { name: 'ساعت شنی', desc: '+۱۰٪ مدت‌زمان' },
    fortune: { name: 'سکه‌ی اقبال', desc: '+۴٪ ضربه‌ی کاری، +۱۰٪ طلا' },
    prism: { name: 'عدسی منشوری', desc: '+۵٪ شانس ضربه‌ی کاری' },
    pact: { name: 'پیمان خون', desc: '+۶٪ آسیب، +۱۰ حداکثر جان' },
    runestone: { name: 'سنگ رون', desc: '+۶٪ گستره و مدت‌زمان' },
    pearl: { name: 'مروارید ماه', desc: '+۸٪ شانس گزینه‌ی چهارم' },
  },
  characters: {
    aria: { name: 'آریا', title: 'اسرارآموز', perk: '+۱۰٪ تجربه' },
    kael: { name: 'کائل', title: 'آتش‌افروز', perk: '+۱۰٪ آسیب' },
    nyx: { name: 'نیکس', title: 'تیغ‌سایه', perk: '+۱۲٪ سرعت حرکت' },
    thora: { name: 'تورا', title: 'فراخواننده‌ی طوفان', perk: '-۸٪ زمان بازیابی' },
    brann: { name: 'بران', title: 'نگهبان زمین', perk: '+۳۰ جان، +۱ زره' },
    lyra: { name: 'لیرا', title: 'یخ‌بافنده', perk: '+۱۰٪ گستره و مدت‌زمان' },
  },
  shop: {
    might: { name: 'قدرت', desc: '+۵٪ آسیب' },
    vitality: { name: 'سرزندگی', desc: '+۱۰ حداکثر جان' },
    haste: { name: 'شتاب', desc: '-۳٪ زمان بازیابی' },
    armor: { name: 'زره', desc: '+۱ زره' },
    regen: { name: 'بازیابی', desc: '+۰٫۱ جان در ثانیه' },
    speed: { name: 'چابکی', desc: '+۴٪ سرعت حرکت' },
    magnet: { name: 'آهن‌ربایی', desc: '+۱۰٪ شعاع جمع‌آوری' },
    growth: { name: 'خرد', desc: '+۵٪ تجربه' },
    greed: { name: 'طمع', desc: '+۱۰٪ طلا' },
    area: { name: 'دامنه', desc: '+۴٪ گستره' },
    reroll: { name: 'بینش', desc: '+۱ تعویض در هر نبرد' },
    revive: { name: 'خاکستر ققنوس', desc: 'یک بار در هر نبرد زنده می‌شوید' },
  },
  gear: {
    ember_staff: { name: 'عصای اخگر' },
    thorn_wand: { name: 'ترکه‌ی خار' },
    storm_rod: { name: 'چوبدست طوفان' },
    void_scepter: { name: 'عصای شاهی خلأ' },
    warded_robe: { name: 'ردای محافظ' },
    moss_robe: { name: 'ردای خزه‌باف' },
    iron_mantle: { name: 'شنل آهنین' },
    shadow_cloak: { name: 'شنل سایه' },
    glass_charm: { name: 'طلسم شیشه‌ای' },
    hourglass_pendant: { name: 'آویز ساعت شنی' },
    sage_locket: { name: 'گردنبند فرزانه' },
    star_talisman: { name: 'تعویذ ستاره' },
    sun_ring: { name: 'انگشتر خورشید' },
    lode_band: { name: 'حلقه‌ی آهن‌ربا' },
    gilded_ring: { name: 'انگشتر زرنشان' },
    hawk_ring: { name: 'انگشتر شاهین' },
    pointed_hat: { name: 'کلاه نوک‌تیز' },
    storm_hood: { name: 'کلاه‌شنل طوفان' },
    ember_circlet: { name: 'دیهیم اخگر' },
    scholar_cap: { name: 'کلاه دانش‌پژوه' },
    wind_striders: { name: 'چکمه‌های بادرو' },
    iron_greaves: { name: 'ساق‌بند آهنین' },
    ember_treads: { name: 'پاپوش اخگر' },
    moss_sandals: { name: 'صندل خزه‌ای' },
  },
  enemies: {
    sproutling: { name: 'نهالک' },
    gloombat: { name: 'خفاش تیره' },
    thornspitter: { name: 'خارافکن' },
    mosshulk: { name: 'غول خزه‌ای' },
    ash_crawler: { name: 'خزنده‌ی خاکستری' },
    cinder_imp: { name: 'شیطانک اخگری' },
    ember_wisp: { name: 'شعله‌ی سرگردان' },
    ash_bat: { name: 'خفاش خاکستری' },
    magma_golem: { name: 'گولم گدازه' },
    frost_shard: { name: 'ترکش یخ' },
    frost_wolf: { name: 'گرگ یخی' },
    snow_owl: { name: 'جغد برفی' },
    frost_wraith: { name: 'شبح یخی' },
    yeti: { name: 'یتی' },
    skeleton: { name: 'اسکلت متحرک' },
    wailing_ghost: { name: 'روح نالان' },
    necro_acolyte: { name: 'نوآموز احضارگر' },
    bone_golem: { name: 'گولم استخوانی' },
    storm_sprite: { name: 'پری طوفانی' },
    harpy: { name: 'هارپی' },
    crag_hound: { name: 'سگ صخره‌ای' },
    thunder_shaman: { name: 'شمن تندر' },
    stone_giant: { name: 'غول سنگی' },
    void_mite: { name: 'کنه‌ی تهی' },
    void_splitter: { name: 'شکافنده‌ی تهی' },
    rift_stalker: { name: 'شکارچی شکاف' },
    abyss_eye: { name: 'چشم ژرفا' },
    void_behemoth: { name: 'بهموت تهی' },
    elder_treant: { name: 'پیر درختان', title: 'نگهبان دره‌ی سرسبز' },
    molten_colossus: { name: 'غول‌پیکر گداخته', title: 'قلب خاکستر' },
    frost_matriarch: { name: 'بانوی یخ', title: 'ملکه‌ی شب بلند' },
    lich_king: { name: 'پادشاه لیچ', title: 'ارباب مردگان غرق‌شده' },
    thunder_titan: { name: 'تیتان تندر', title: 'صدای طوفان' },
    hollow_star: { name: 'ستاره‌ی تهی', title: 'گرسنگی میان جهان‌ها' },
    lut_scarab: { name: 'سوسک شن' },
    lut_vulture: { name: 'کرکس کویر' },
    lut_scorpion: { name: 'عقرب لوت' },
    desert_ghoul: { name: 'غول بیابان' },
    kalut_golem: { name: 'غول‌سنگ کلوت' },
    div_spawn: { name: 'دیوچه' },
    forest_raven: { name: 'کلاغ جنگل' },
    div_shaman: { name: 'دیو افسونگر' },
    div_witch: { name: 'زن جادو' },
    horned_div: { name: 'دیو شاخدار' },
    zahhak_serpent: { name: 'مار ضحاک' },
    ash_harpy: { name: 'هارپی خاکستر' },
    fire_div: { name: 'دیو آتش' },
    serpent_charmer: { name: 'مارافسا' },
    magma_div: { name: 'دیو گدازه' },
    azhdaha: { name: 'اژدها', title: 'مار شن‌های سوزان' },
    white_div: { name: 'دیو سپید', title: 'سرور مازندران' },
    zahhak: { name: 'ضحاک', title: 'شاه ماردوش' },
    brazier: { name: 'آتشدان' },
  },
  stages: {
    verdant: { name: 'دره‌ی سرسبز', subtitle: 'چمنزاری آفتابی که درختانش زمزمه می‌کنند' },
    ashen: { name: 'برهوت خاکستر', subtitle: 'خاکش هنوز آتش را به یاد دارد' },
    frost: { name: 'دامنه‌ی نیش یخ', subtitle: 'جایی که باد دندان دارد' },
    crypt: { name: 'سردابه‌ی غرق‌شده', subtitle: 'مردگان غرق‌شده آرام نمی‌گیرند' },
    storm: { name: 'قله‌های طوفان', subtitle: 'فراتر از ابرها، آسمان خشمگین است' },
    void: { name: 'شکاف تهی', subtitle: 'اینجا واقعیت به پایان می‌رسد' },
    lut: { name: 'دشت لوت', subtitle: 'داغ‌ترین خاک زیر آفتاب' },
    mazandaran: { name: 'جنگل مازندران', subtitle: 'جایی که رستم با دیوها روبه‌رو شد' },
    damavand: { name: 'دماوند', subtitle: 'شاه دربند بیدار می‌شود' },
  },
};
